var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftLong(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.496 18.8a1.68 1.68 0 000 2.383l9.561 9.569a1.687 1.687 0 002.383-2.383l-6.678-6.68 28.55-.006c.936 0 1.688-.753 1.688-1.688 0-.935-.752-1.687-1.687-1.687H7.762l6.679-6.68c.66-.66.66-1.729 0-2.383a1.687 1.687 0 00-2.384 0L2.496 18.8z"
  })));
}
export default SvgArrowLeftLong;